import { type WorkflowFiltersShape } from "@bastion/assistant";
import {
  decodeFilterStateFromParams,
  type FilterState,
} from "@bastion/list-view";
import { WORKFLOW_FILTER_IDS } from "@bastion/ml-studio";

const WORKFLOWS_PATHNAME = "/ml-studio/workflows";

function valuesFor(state: FilterState, attributeId: string): string[] | undefined {
  const entry = state.filters.find((f) => f.attributeId === attributeId);
  if (!entry || entry.values.length === 0) {
    return undefined;
  }
  // Operator info is dropped here — Gauss only needs a snapshot of the selected
  // values. The full chip shape (including operator) is round-tripped via the
  // URL when the model writes via `set_workflow_filters`.
  return entry.values.slice();
}

/**
 * Build a workflow filter snapshot for the assistant when the user is on the
 * workflows page. Returns `undefined` (so `buildAssistantAppState` falls back
 * to its defaults) on every other page — keeping irrelevant pages from
 * polluting Gauss's app-state context.
 */
export function readWorkflowFiltersFromLocation(
  pathname: string,
  search: string,
): WorkflowFiltersShape | undefined {
  if (pathname !== WORKFLOWS_PATHNAME && !pathname.startsWith(`${WORKFLOWS_PATHNAME}?`)) {
    return undefined;
  }
  const params = new URLSearchParams(search);
  const filterState = decodeFilterStateFromParams(params, WORKFLOW_FILTER_IDS);

  return {
    status: valuesFor(filterState, "status"),
    tag: valuesFor(filterState, "tag"),
    workflowName: valuesFor(filterState, "workflow_name"),
  };
}
